import { PostsRoutes } from '@/repository/resources';
const { LikeAPost } = PostsRoutes;

export default {
	namespaced: true,
	actions: {
		async store({ commit }, { post }) {
			try {
				let res = await LikeAPost({ post });
				this.commit('posts/EDIT_POST', res.data)
				return res
			}
			catch (error) {
				console.error('Problem occurred when liking post.', error);
				throw error;
			}
		}

	}
}